import React from 'react';
import ContactIcons from './ContactIcons';
import ThemePicker from './ThemePicker';

const PageFooter = () => (
  <div className="footer">
    <div className="placeholder" />
    <ContactIcons />
    <ThemePicker />
  </div>
);

export default PageFooter;



// WEBPACK FOOTER //
// ./src/components/PageFooter.js